const vendorCategories = [
    {
      category: "Real Estate Agents",
      description: "Help with finding and purchasing properties. Provide guidance on property market trends and legal aspects."
    },
    {
      category: "Architects",
      description: "Assist in designing the layout and structure of the house. Create blueprints and plans for the construction."
    },
    {
      category: "Surveyors",
      description: "Conduct land surveys to determine property boundaries and topography. Provide elevation and boundary information."
    },
    {
      category: "Builders/Contractors",
      description: "Oversee the actual construction process. Manage construction crews and subcontractors."
    },
    {
      category: "Plumbers",
      description: "Install plumbing systems, including water supply and drainage. Ensure proper plumbing connections and fixtures."
    },
    {
      category: "Electricians",
      description: "Install electrical systems, wiring, and outlets. Ensure compliance with electrical codes and safety standards."
    },
    {
      category: "Roofing Contractors",
      description: "Install the roofing structure and materials. Ensure proper insulation and weatherproofing."
    },
    {
      category: "Carpenters",
      description: "Work on interior and exterior woodwork, including doors and windows. May build custom furniture or cabinetry."
    },
    {
      category: "Masons",
      description: "Construct the foundation and walls. Work on brickwork, stonework, or concrete."
    },
    {
      category: "Painters",
      description: "Apply paint and finishes to the interior and exterior of the house. Provide decorative and protective coatings."
    },
    {
      category: "Landscapers",
      description: "Design and create the landscaping around the property. Install gardens, lawns, and hardscapes."
    },
    {
      category: "Interior Designers",
      description: "Assist with selecting interior finishes, colors, and furnishings. Ensure a cohesive and aesthetically pleasing interior design."
    },
    {
      category: "HVAC Contractors",
      description: "Install heating and cooling systems. Ensure proper ventilation and climate control."
    },
    {
      category: "Insulation Contractors",
      description: "Install insulation materials to improve energy efficiency. Ensure proper insulation in walls, floors, and roofs."
    },
    {
      category: "Security System Installers",
      description: "Set up security and surveillance systems. Install alarms, cameras, and access control."
    },
    {
      category: "Planners/Project Managers",
      description: "Oversee the entire project, managing timelines and budgets. Coordinate all vendors and services."
    },
    {
      category: "Legal Advisors",
      description: "Provide legal counsel regarding property transactions and contracts. Ensure compliance with local building regulations."
    },
    {
      category: "Financial Institutions",
      description: "Assist with financing options for land purchase and construction loans."
    },
    {
      category: "Material Suppliers",
      description: "Provide building materials, such as lumber, cement, and fixtures."
    },
    {
      category: "Home Inspectors",
      description: "Conduct inspections at various construction stages to ensure quality and compliance."
    },
    {
      category: "Environmental Consultants",
      description: "Address environmental concerns and regulations related to construction."
    },
    {
      category: "Utilities Services",
      description: "Coordinate the connection of water, electricity, gas, and sewage services."
    },
    {
      category: "Waste Management Services",
      description: "Manage construction debris and waste disposal."
    },
    {
      category: "Insurance Providers",
      description: "Offer construction and homeowner's insurance coverage."
    },
    {
      category: "Home Automation and Technology Integrators",
      description: "Install smart home systems and technology solutions."
    }
  ];
  
  export default vendorCategories